<template>
    <div class="home">
        <div class="field is-grouped">
            <div class="control">
                <router-link to="/project/" class="button is-primary">Create Project</router-link>
            </div>
            <div class="control">
                <router-link to="/meta" class="button">Edit Meta</router-link>
            </div>
            <div class="control">
                <a class="button" :class="{'is-primary': editingProjectOrder}" @click="toggleEditProjectOrder">{{ editingProjectOrder ? 'Save' : 'Edit' }} Project Order</a>
            </div>
        </div>

        <draggable v-model="orderableProjects" class="home-projects" @start="drag=true" @end="drag=false" :options="{disabled: !editingProjectOrder}">
            <router-link v-for="project of (editingProjectOrder ? orderableProjects : projects)" :key="project['.key']" :to="`/project/${project['.key']}`" class="card">
                <div class="card-image">
                    <div class="image is-3by2"
                         :style="{backgroundImage: `url('${contentUrlPrefix + project.images[Object.keys(project.images)[0]].url}')`}"></div>
                </div>
                <div class="card-content">
                    <!--suppress JSUnresolvedVariable -->
                    <div class="featured-toggle" :class="{featured: project.featured}" @click="toggleFeatured(project['.key'], $event)">
                        <font-awesome-icon :icon="[project.featured ? 'fas' : 'far', 'star']"/>
                    </div>
                    <h1 class="subtitle">{{project.name}} <span v-if="project.draft" class="has-text-grey-light">(Draft)</span></h1>
                    <p v-if="project.notes" v-split>{{project.notes}}</p>
                </div>
            </router-link>
        </draggable>
    </div>
</template>

<script>
    import Draggable from 'vuedraggable';
    import {contentUrlPrefix, triggerSiteBuild} from "../firebase";
    import {PUSH_MESSAGE} from "../store";

    export default {
        name: "home",
        data() {
            return {
                contentUrlPrefix,
                removeModalKey: "",
                removeModalShown: false,
                editingProjectOrder: false,
                orderableProjects: []
            }
        },
        computed: {
            projects: {
                get() {
                    return this.$store.state.projects;
                },
                set(newProjects) {
                    this.$store.$firebaseRefs.projects.remove();
                    for(let project of newProjects) {
                        delete project['.key'];
                        this.$store.$firebaseRefs.projects.push(project);
                    }
                    triggerSiteBuild("Update Project Order");
                }
            }
        },
        methods: {
            toggleEditProjectOrder() {
                if(!this.editingProjectOrder) {
                    this.orderableProjects = [...this.projects];
                    this.editingProjectOrder = true;
                } else {
                    this.projects = this.orderableProjects;
                    this.editingProjectOrder = false;
                    this.orderableProjects = [];
                }
            },
            toggleFeatured(key, e) {
                e.preventDefault();
                const currentProject = this.projects.find(project => project['.key'] === key);
                // noinspection JSUnresolvedVariable
                this.$store.$firebaseRefs.projects
                    .child(key)
                    .child("featured")
                    .set(!currentProject.featured);
                triggerSiteBuild(`Updated ${currentProject.name}`);
                this.$store.dispatch(PUSH_MESSAGE, {
                    title: "Success",
                    message: `Project updated! It may take up to 5 minutes for changes to be visible.`,
                    type: "success"
                });
            }
        },
        directives: {
            split: {
                inserted(el) {
                    el.innerHTML = el.innerHTML.split("\n").join("<br>");
                }
            }
        },
        mounted() {
            document.title = "CMS";
        },
        components: {
            Draggable
        }
    }
</script>

<style lang="scss">
    @import "~bulma/sass/utilities/initial-variables";

    .home .home-projects {
        margin-top: 8px;
        margin-bottom: 16px;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 16px;

        @media(max-width: $tablet) {
            grid-template-columns: 1fr;
        }
    }

    .home .card {
        .card-image .image {
            background-position: center;
            background-size: cover;
        }

        .card-content {
            position: relative;

            h1 {
                width: 85%;
            }

            .featured-toggle {
                position: absolute;
                top: 1.5rem;
                right: 1.5rem;

                &.featured {
                    color: $yellow;
                }
            }
        }
    }
</style>
